export const BRAND = {
    name: "RP Traders",
    established: "2016",
    gstn: "37AALPE2217Q1ZF",
    email: "info@rptradersiec.com",
    phone: "+91 94910 85798",
    phoneIntl: "919491085798",
    leadWhatsapp: "919347304584",
    head: "502, Kubera Towers, Arundalpet, Guntur–522002, Andhra Pradesh",
    branch: "10/G4, Ground Floor, Ratna Complex, Ameerpet–500016, Telangana",
    logo: "https://customer-assets.emergentagent.com/job_d14a613f-5f80-42c7-a541-0a7988797d3f/artifacts/xynkp6pn_WhatsApp%20Image%202026-05-08%20at%205.06.54%20PM.jpeg",
    mapEmbed:
        "https://www.google.com/maps?q=Kubera+Towers,+Arundalpet,+Guntur,+Andhra+Pradesh+522002&output=embed",
    catalogPdf:
        "https://customer-assets.emergentagent.com/job_teja-turmeric/artifacts/zpo5xnxd_Catalogue.pdf",
};

export const HERO_SLIDES = [
    {
        url: "https://customer-assets.emergentagent.com/job_teja-turmeric/artifacts/7ey9jc7s_image.png",
        alt: "RP Traders export warehouse — workers grading chilli sacks, container loading in progress",
        kicker: "Export Warehouse · Guntur",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_teja-turmeric/artifacts/sp1ntjnh_image.png",
        alt: "Indian women farmers proudly holding handfuls of harvested red chillies",
        kicker: "Farm-direct Sourcing",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_teja-turmeric/artifacts/59lgj9ej_image.png",
        alt: "Hand-graded premium red chillies — close-up of dried pods",
        kicker: "Premium Grade · Hand Inspected",
    },
    {
        url: "https://images.unsplash.com/photo-1602237514002-c2d8ae2da393?fm=jpg&q=85&w=2400&auto=format&fit=crop",
        alt: "Cinematic pile of dried red Guntur Teja chillies",
        kicker: "Guntur Teja · Deep Red",
    },
    {
        url: "https://images.unsplash.com/photo-1761048158383-50372fed6f73?fm=jpg&q=85&w=2400&auto=format&fit=crop",
        alt: "Sun-dried red chillies hanging at golden hour",
        kicker: "Sun-dried · Lab-tested",
    },
    {
        url: "https://images.unsplash.com/photo-1771769606888-86e2f4c6c65e?fm=jpg&q=85&w=2400&auto=format&fit=crop",
        alt: "Sorting and packing red chillies into export sacks",
        kicker: "Export-ready Packaging",
    },
];

export const PRODUCT_CAROUSEL = [
    "https://images.unsplash.com/photo-1602237514002-c2d8ae2da393?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1609158793803-7060643f9168?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1711216367582-659a87c89f5b?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1761048158383-50372fed6f73?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1771769606888-86e2f4c6c65e?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1759255260667-6c93b7569741?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1768729340164-7d83fe18384d?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1526576935508-6bccc1e07580?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1548368197-2fdad2455b9c?fm=jpg&q=85&w=1920&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1743810746241-9cff292b62ac?fm=jpg&q=85&w=1920&auto=format&fit=crop",
];

export const GALLERY = [
    "https://images.unsplash.com/photo-1602237514002-c2d8ae2da393?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1761048158383-50372fed6f73?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1771769606888-86e2f4c6c65e?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1759255260667-6c93b7569741?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1711216367582-659a87c89f5b?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1609158793803-7060643f9168?fm=jpg&q=85&w=1400&auto=format&fit=crop",
    "https://images.unsplash.com/photo-1743810746241-9cff292b62ac?fm=jpg&q=85&w=1400&auto=format&fit=crop",
];

export const PRODUCTS = [
    {
        slug: "red-chilli",
        id: "red-chilli",
        name: "Red Chilli",
        h1: "Red Chilli Exporter from India",
        tag: "All grades · Sun-dried · Export quality",
        blurb:
            "Premium Indian red chilli sourced direct from Andhra Pradesh and Telangana farms. Vibrant red colour, consistent heat, low moisture — graded for global food brands, retailers and spice processors.",
        image: "https://images.unsplash.com/photo-1602237514002-c2d8ae2da393?fm=jpg&q=85&w=1600&auto=format&fit=crop",
        keywords:
            "red chilli exporter from India, dried red chilli supplier, Indian red chilli wholesaler, bulk red chilli export",
        grades: ["Teja S17", "334 / Sannam S4", "Wonder Hot", "Byadgi"],
        specs: [
            { k: "Heat", v: "30,000 – 90,000 SHU" },
            { k: "Colour", v: "80 – 140 ASTA" },
            { k: "Moisture", v: "≤ 10%" },
            { k: "Form", v: "Whole, stem-on / stemless" },
        ],
        packaging: ["10 / 20 / 25 kg PP bags", "Jute export bags", "Private-label retail"],
        markets: ["UAE", "Saudi Arabia", "Malaysia", "USA", "Netherlands"],
    },
    {
        slug: "guntur-red-chilli",
        id: "guntur-red-chilli",
        name: "Guntur Red Chilli (Teja)",
        h1: "Guntur Red Chilli Exporter from India",
        tag: "Teja · 334 · Sannam",
        blurb:
            "From the chilli capital of India — Guntur's famed Teja and 334/Sannam varieties. Deep red colour, intense pungency and a clean break, packed under our IEC and Spices Board export registration.",
        image: "https://images.unsplash.com/photo-1609158793803-7060643f9168?fm=jpg&q=85&w=1600&auto=format&fit=crop",
        keywords:
            "Guntur red chilli exporter, Teja chilli supplier, 334 Sannam chilli, Guntur chilli wholesale",
        grades: ["Teja S17 (high pungency)", "334 / Sannam S4", "Wonder Hot"],
        specs: [
            { k: "Heat", v: "75,000 – 90,000 SHU (Teja)" },
            { k: "Colour", v: "120 – 140 ASTA" },
            { k: "Moisture", v: "≤ 10%" },
            { k: "Pod length", v: "5 – 8 cm" },
        ],
        packaging: ["10 / 20 / 25 kg PP bags", "Jute export bags"],
        markets: ["UAE", "Saudi Arabia", "Sri Lanka", "Malaysia", "USA"],
    },
    {
        slug: "turmeric",
        id: "turmeric",
        name: "Turmeric (Fingers & Powder)",
        h1: "Turmeric Exporter from India",
        tag: "Fingers · Powder · Steam-sterilised",
        blurb:
            "High-curcumin turmeric from Erode and Nizamabad. Available as polished/unpolished fingers and fine-mesh powder — milled in food-safe facilities for retailers and processors.",
        image: "https://images.unsplash.com/photo-1768729340164-7d83fe18384d?fm=jpg&q=85&w=1600&auto=format&fit=crop",
        keywords:
            "turmeric exporter from India, turmeric fingers supplier, curcumin turmeric powder",
        grades: ["Erode Fingers", "Nizamabad Fingers", "Polished / Unpolished", "Steam-sterilised powder"],
        specs: [
            { k: "Curcumin", v: "2.5 – 5.0%" },
            { k: "Moisture", v: "≤ 10%" },
            { k: "Mesh (powder)", v: "60 – 80" },
            { k: "Colour", v: "Bright golden yellow" },
        ],
        packaging: ["25 / 50 kg PP & jute bags", "Retail pouches 200 g – 1 kg"],
        markets: ["USA", "Germany", "UK", "UAE", "Singapore"],
    },
    {
        slug: "coriander",
        id: "coriander",
        name: "Coriander Seeds",
        h1: "Coriander Exporter from India",
        tag: "Eagle · Single / Split",
        blurb:
            "Aromatic, light-yellow coriander seeds from Rajasthan and Madhya Pradesh — clean, machine-sorted and packed for spice processors, blenders and retail brands worldwide.",
        image: "https://images.pexels.com/photos/606540/pexels-photo-606540.jpeg?auto=compress&cs=tinysrgb&w=1600",
        keywords:
            "coriander exporter from India, coriander seeds supplier, dhania export India",
        grades: ["Eagle quality", "Scooter", "Single & Split"],
        specs: [
            { k: "Purity", v: "≥ 99%" },
            { k: "Moisture", v: "≤ 9%" },
            { k: "Admixture", v: "≤ 1%" },
            { k: "Colour", v: "Light yellow-green" },
        ],
        packaging: ["25 / 50 kg PP bags", "Jute export bags"],
        markets: ["UAE", "Qatar", "Saudi Arabia", "UK", "Singapore"],
    },
    {
        slug: "cumin",
        id: "cumin",
        name: "Cumin Seeds (Jeera)",
        h1: "Cumin Exporter from India",
        tag: "Singapore / Europe quality",
        blurb:
            "Premium Gujarati and Rajasthani cumin (jeera) — handpicked, machine-cleaned and steam-treatable on request. Strong aroma, low admixture, ready for bulk export.",
        image: "https://images.pexels.com/photos/1340116/pexels-photo-1340116.jpeg?auto=compress&cs=tinysrgb&w=1600",
        keywords:
            "cumin exporter from India, jeera supplier, Indian cumin seeds wholesale, Singapore cumin",
        grades: ["Singapore quality 99%", "Europe quality 99.5%", "Machine cleaned"],
        specs: [
            { k: "Purity", v: "99% – 99.5%" },
            { k: "Moisture", v: "≤ 8%" },
            { k: "Admixture", v: "≤ 1%" },
            { k: "Volatile oil", v: "≥ 2.5%" },
        ],
        packaging: ["25 / 50 kg PP bags", "Vacuum-pack on request"],
        markets: ["UAE", "Saudi Arabia", "Netherlands", "Germany", "USA"],
    },
    {
        slug: "indian-spices",
        id: "indian-spices",
        name: "Indian Spices · Mixed Range",
        h1: "Indian Spices Exporter — Mixed Range",
        tag: "Black pepper · Mustard · Fenugreek · Fennel",
        blurb:
            "Beyond chilli and turmeric, we supply a full range of Indian whole and ground spices — sourced from the right region for each crop and packed under our export licenses.",
        image: "https://images.unsplash.com/photo-1532336414038-cf19250c5757?fm=jpg&q=85&w=1600&auto=format&fit=crop",
        keywords:
            "Indian spices exporter, bulk spice supplier India, whole spices wholesale, Indian masala export",
        grades: ["Black pepper TGSEB / MG1", "Mustard yellow / black", "Fenugreek", "Fennel"],
        specs: [
            { k: "Purity", v: "≥ 99%" },
            { k: "Moisture", v: "Crop-specific spec" },
            { k: "Packaging", v: "25 / 50 kg / private-label" },
            { k: "Lab tests", v: "Moisture, ASTA, microbial" },
        ],
        packaging: ["25 / 50 kg PP / jute bags", "Private-label retail packs"],
        markets: ["UAE", "Saudi Arabia", "USA", "UK", "Germany", "Malaysia"],
    },
];

export const PRODUCT_BY_SLUG = Object.fromEntries(PRODUCTS.map((p) => [p.slug, p]));

export const NAV_LINKS = [
    { href: "/products", label: "Products" },
    { href: "/#about", label: "About" },
    { href: "/#why", label: "Why Us" },
    { href: "/#certs", label: "Certifications" },
    { href: "/#global", label: "Global" },
    { href: "/contact", label: "Contact" },
];

export const MARKETS = [
    "UAE", "Saudi Arabia", "Qatar", "Oman",
    "Netherlands", "Germany", "United Kingdom", "USA",
    "Singapore", "Malaysia", "Vietnam", "Sri Lanka",
];

export const TRUST_ITEMS = [
    { title: "IEC Registration", body: "Issued by DGFT, Govt. of India — Import Export Code on file." },
    { title: "FSSAI Licensed", body: "Food Safety & Standards Authority of India licensed business." },
    { title: "Spices Board Registered", body: "Registered Exporter under the Spices Board, Min. of Commerce." },
    { title: "APEDA Aligned", body: "Documentation aligned with APEDA agri-product export standards." },
    { title: "Lab-Tested Quality", body: "Every consignment tested for moisture, ASTA, SHU, curcumin, microbial." },
    { title: "Export Documentation", body: "Certificate of Origin, Phytosanitary, Fumigation, Bill of Lading." },
    { title: "Secure Packaging", body: "Custom PP, jute, vacuum or private-label retail packs." },
    { title: "Timely Shipment", body: "FOB / CIF / CFR ex Chennai, Krishnapatnam, Mundra." },
];
